<div class="top">
  <div class="table" #tableDiv>
    @if (useGlobalFilter) {
      <mat-form-field
        style="width: 100%; margin-bottom: 0.5em"
        appearance="outline"
        >
        <mat-label>Filter</mat-label>
        <input
          matInput
          #inputEl
          [(ngModel)]="filter"
          [mention]="columns"
          [mentionConfig]="filterMentionConfig"
          [mentionListTemplate]="filterMentionTemplate"
          (opened)="setSearchDisabled(true)"
          (closed)="setSearchDisabled(false)"
          />
        @if (filter()) {
          <button
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="inputEl.value = ''; filter.set('')"
            >
            <mat-icon>close</mat-icon>
          </button>
        }
        <mat-hint
          ><em>=Anna</em> finds exact matches; <em>^=Anna</em> finds at start;
          <em>$=</em> finds at end; <em>&lt;</em>, <em>&leq;</em>, <em>&gt;</em>,
          <em>&geq;</em> are comparisons; wrap with &quot; if needed (e.g.
          <em>="Anna Maria"</em>); use # to show field names
        </mat-hint>
        <ng-template #filterMentionTemplate let-item="item">
          <div style="min-width: 300px; display: flex">
            <div style="flex-grow: 1">
              <ng-container
                *ngTemplateOutlet="getHeaderTemplate(item.label)"
              ></ng-container>
            </div>
            [{{ item.label }}]
          </div>
        </ng-template>
      </mat-form-field>
    }

    <table
      mat-table
      [dataSource]="dataSource"
      [trackBy]="trackBy"
      matSort
      (matSortChange)="onSort($event)"
      #matSort="matSort"
      >
      <ng-content></ng-content>

      @let headerRow = showColumnsForRows().$header;
      @let filterRow = showColumnsForRows().$filter;
      <tr
        mat-header-row
        *matHeaderRowDef="headerRow[0]; sticky: headerRow[1]"
        #header
      ></tr>
      <tr
        mat-header-row
        *matHeaderRowDef="filterRow[0]; sticky: filterRow[1]"
        class="filter-row"
        (input)="onFilterRowChanged($event)"
      ></tr>
      @for (additionalHeaderRow of additionalHeaderRows(); track $index) {
        <tr
          mat-header-row
					*matHeaderRowDef="
						showColumnsForRows()[additionalHeaderRow[0]][0];
						sticky: additionalHeaderRow[1]
					"
        ></tr>
      }
      <tr
        mat-row
        *matRowDef="let item; let index = index; columns: headerRow[0]"
        (click)="rowClick.emit([$event, item, index])"
        [style]="rowStyleFn?.(item, surroundingScope) ?? ''"
      ></tr>
      @for (additionalFooterRow of additionalFooterRows(); track $index) {
        <tr
          mat-footer-row
					*matFooterRowDef="
						showColumnsForRows()[additionalFooterRow[0]][0];
						sticky: additionalFooterRow[1]
					"
        ></tr>
      }
    </table>

    @if (usePaging) {
      <mat-paginator
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize"
        [showFirstLastButtons]="true"
        (page)="onPage($event)"
      ></mat-paginator>
    }
    @if (paginator) {
      <input
        #pageNumberInput
        matInput
        class="page-number-input"
        [ngModel]="paginator!.pageIndex + 1"
        (ngModelChange)="jumpToPageNumber($event)"
			[disabled]="
				paginator!.disabled || paginator!.pageSize >= paginator!.length
			"
        />
    }
  </div>

  @if (showSettings) {
    <mat-icon
      class="settings-trigger"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      (click)="toggleOverlay()"
      >settings</mat-icon
      >
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="isOverlayOpen"
        [cdkConnectedOverlayHasBackdrop]="isOverlayOpen"
        (backdropClick)="toggleOverlay()"
        >
        <div class="settings-overlay">
          @if (userDefinedConfiguration) {
            <div>
              <mat-form-field style="width: 100%">
                <mat-label>View</mat-label>
                <mat-select
                  [(ngModel)]="currentView"
                  (ngModelChange)="reloadView()"
                  >
                  <mat-option [value]="''">
                    <span>(Standard)</span>
                    @if (!currentView && isViewDirty) {
                      <span>*</span>
                    }
                    @if (!configurations.defaultView) {
                      <span> [default]</span>
                    }
                  </mat-option>
                  @for (item of configurations.views | keyvalue; track item) {
                    <mat-option
                      [value]="item.key"
                      >
                      <span>{{ item.key }}</span>
                      @if (item.key == currentView && isViewDirty) {
                        <span>*</span>
                      }
                      @if (item.key == configurations.defaultView) {
                        <span>
                          [default]</span
                          >
                        }
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <div class="settings-button-row">
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="saveView()"
                    [disabled]="!isViewDirty || !currentView"
                    >
                    Save
                  </button>
                  <button mat-stroked-button color="primary" (click)="saveViewAs()">
                    Save as
                  </button>
                  <button
                    mat-stroked-button
                    color="accent"
                    (click)="reloadView()"
                    [disabled]="!isViewDirty"
                    >
                    Revert
                  </button>
                  <button
                    mat-stroked-button
                    color=""
                    (click)="makeDefaultView()"
                    [disabled]="currentView == configurations.defaultView"
                    >
                    Make default
                  </button>
                  <button
                    mat-stroked-button
                    color="warn"
                    (click)="deleteView()"
                    [disabled]="!currentView"
                    >
                    Delete
                  </button>
                </div>
              </div>
            }
            <div class="settings-filter-row">
              <div><strong>Filters</strong></div>
              @if (
                mergeFilters(filter(), columnFiltersSubject.value); as filter) {
                <div
                  >
                  <code>{{ filter }}</code>
                </div>
              } @else {
                <em>(none)</em>
              }
            </div>
            <div class="columns-grid">
              <div>
                <strong>Hidden columns</strong>
                <div
                  cdkDropList
                  #hiddenCols="cdkDropList"
                  class="column-list"
                  [cdkDropListData]="hiddenColumns"
                  [cdkDropListConnectedTo]="[shownCols]"
                  (cdkDropListDropped)="dropOverlayColumn($event)"
                  >
                  @for (col of hiddenColumns; track col) {
                    <div
                      class="column-list-item"
                      cdkDrag
                      >
                      <ng-container
                        *ngTemplateOutlet="getHeaderTemplate(col)"
                      ></ng-container>
                      [{{ col }}]
                    </div>
                  }
                </div>
              </div>
              <div>
                <strong>Shown columns</strong>
                <div
                  cdkDropList
                  #shownCols="cdkDropList"
                  class="column-list"
                  [cdkDropListData]="showColumns()"
                  [cdkDropListConnectedTo]="[hiddenCols]"
                  (cdkDropListDropped)="dropOverlayColumn($event)"
                  >
                  @for (col of showColumns(); track col) {
                    <div
                      class="column-list-item"
                      cdkDrag
                      >
                      <ng-container
                        *ngTemplateOutlet="getHeaderTemplate(col)"
                      ></ng-container>
                      [{{ col }}]
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      }
    </div>
